
import slices from './slices';

export const reducers = {
    availability: slices.availabilitySlice.reducer,
};

export default slices.availabilitySlice.reducer;
